// The map toolbar's buttons are declared in each map app as data
// ({ name: 'Maps', icon: 'layers', … }) and drawn by MapButtons.vue. The names
// double as identifiers in those apps, so they stay English there and are
// translated here, at the one place they are shown.
//
// Each key is named in a literal t() call so the client bundle ships it (see
// lib/i18n_client_bundle.rb). A name with no translation is shown as it is:
// "Garmin" is a brand.
type Translate = (key: string) => string

export function mapButtonLabel (name: string | undefined, t: Translate): string {
  switch (name) {
    case 'Maps': return t('shared.maps')
    case 'Options': return t('map_options_dialog.options')
    default: return name ?? ''
  }
}
